import PanelDismiss from "./panel-dismiss";
import { useUI, useCategory } from "../contexts";
import { useSearch } from "@/contexts/SearchProvider";
import Link from "next/link";

const CategoryNav = ({ cat, setCategoryDrawerOpen, setRecentCategory, setCurrentCategoryGroupId }) => {
  const { label, slug, id } = cat;
  const href = slug == "" ? "/" : `/browse/${slug}`;
  return (
    <Link
      href={href}
      onClick={() => {
        setCategoryDrawerOpen(false);
        setCurrentCategoryGroupId(id);
        setRecentCategory(cat);
      }}
      className="category-nav"
    >
      {label}
    </Link>
  );
};

const NavCategoryDrawer = () => {
  const { categoryDrawerOpen, setCategoryDrawerOpen } = useUI();
  const { setRecentCategory, setCurrentCategoryGroupId } = useSearch();
  const { categories, loading } = useCategory();

  // Filter to get only parent categories (not subcategories)
  const parentCategories = categories
    .filter(cat => !cat.parentId && cat.id !== 31 && cat.id !== 0) // Exclude subcategories, Jobs, and id=0 (reserved for "All")
    .sort((a, b) => (a.sortOrder || 999) - (b.sortOrder || 999));

  // Add "All" category at the beginning
  const allCategory = { id: 0, label: "All", slug: "", sortOrder: 0 };
  const allCategories = [allCategory, ...parentCategories];

  return (
    <>
      <div
        className="nav-category-drawer-bg"
        onClick={() => {
          setCategoryDrawerOpen(false);
        }}
      />
        <PanelDismiss
          className="nav-category-drawer-cont"
          side="Left"
          onChange={() => {
            setCategoryDrawerOpen(false);
          }}
          handle="nav-cat-handle"
          expanded={categoryDrawerOpen}
        >
          <div className="nav-category-drawer">
            <h3 className="shop-by-category-header">Shop by Category</h3>
            <div className="nav-category-drawer-scroller">
              {loading ? (
                <div className="category-loading">Loading categories...</div>
              ) : (
                allCategories.map((cat) => {
                  return (
                    <CategoryNav
                      cat={cat}
                      key={`drawer-cat-${cat.id}`}
                      setCategoryDrawerOpen={setCategoryDrawerOpen}
                      setRecentCategory={setRecentCategory}
                      setCurrentCategoryGroupId={setCurrentCategoryGroupId}
                    />
                  );
                })
              )}
            </div>
          </div>
        </PanelDismiss>
    </>
  );
};

export default NavCategoryDrawer;
